export const PositionalMediaButton3DAttributeValues = {
    // Keyframe values for animating scale of icon for hoverEnter state.  Groups of 3, - x,y,z
    PM_HOVERENTER_ICON_SCALE_ANIM_KEYFRAME_SEQUENCE: [1, 1, 1, 1.1, 1.1, 1.1],

    // Keyframe values for animating scale of icon for hoverExit state.  Groups of 3, - x,y,z
    PM_HOVEREXIT_ICON_SCALE_ANIM_KEYFRAME_SEQUENCE: [1.1, 1.1, 1.1, 1, 1, 1],

    // Sizing and positioning values for root object
    MESH_POSITION: {
        x: -1,
        y: 0,
        z: -1,
    },
    WIDTH: 1,
    HEIGHT: 0.5,

    // Scrub Bar Color
    SCRUB_BAR_COLOR: 0xffffff,

    // Scrub Bar Geometry
    SCRUBBAR_GEOMETRY_WIDTH_COFACTOR: 0.84,
    SCRUBBAR_GEOMETRY_HEIGHT_COFACTOR: 0.2,
    SCRUBBAR_GEOMETRY_EDGE_RADIUS: 0.04,

    // Scrub Bar Position
    SCRUBBAR_POSITION_X_COFACTOR: -0.84,
    SCRUBBAR_POSITION_Y_COFACTOR: -0.84,
    SCRUBBAR_POSITION_Z: 1,

    // Hit mesh customization
    HIT_MESH_OFFSET: -0.1,
}

export const PositionalMediaButton3DSpeeds = {
    // Timing and duration for hoverEnter icon scale
    PM_HOVERENTER_ICON_SCALE_ANIM_TIMING: [0, 0.25],
    PM_HOVERENTER_ICON_SCALE_ANIM_DURATION: 0.25,

    // Timing and duration for hoverExit icon scale
    PM_HOVEREXIT_ICON_SCALE_ANIM_TIMING: [0, 0.25],
    PM_HOVEREXIT_ICON_SCALE_ANIM_DURATION: 0.25,

    // Length of timeout to wait before triggering hide button on hoverExit
    PM_HIDEBUTTON_TIMEOUT_DURATION: 2000,
}
